import React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';

import { FactoryActions } from '../../core/actions';
import { Message, ScrollContainer } from '../../core/ui/components';
import { IColumn, IData, IFactoryPageProps } from '../../core/interfaces';
import { RootState } from '../../core/store';
import { isMobile } from 'react-device-detect';
import { ListStickyHeader } from '../../base/components';


/**
 * Factory component
 *
 * @class Factory
 */
class Factory extends React.Component<IFactoryPageProps & WithTranslation> {

    /**
     * Constructor
     *
     * @param {IProps & WithTranslation} props
     */
    constructor(props: IFactoryPageProps & WithTranslation) {

        super(props);

        const { t } = this.props;

        this.columns = [
            {
                name: 'id',
                label: '#ID',
                sortable: false,
                width: '10%',
            },
            {
                name: 'name',
                label: t('NAME'),
                sortable: false,
                editable: true,
                validation: {
                    required: true,
                    maxLength: 30,
                },
                width: '30%',
            },
            {
                name: 'comment',
                label: t('COMMENT'),
                sortable: false,
                editable: true,
                validation: {
                    required: false,
                    maxLength: 250,
                },
                width: '200px',
            },
        ];

        this.bulkUpdate = this.bulkUpdate.bind(this);
        this.isLandscape = this.isLandscape.bind(this);
    }

    /**
     * Callback after render the component to the DOM
     */
    componentDidMount() {

        this.props.load();
    }

    /**
     * Component props update handler
     *
     * @param {IProps} prevProps Updated component properties
     */
    componentDidUpdate(prevProps: IFactoryPageProps) {

        if (this.props.refresh && prevProps.refresh !== this.props.refresh) {

            this.props.load();
        }
    }

    /**
     * Data table columns
     *
     * @type {IColumn[]}
     */
    private readonly columns: IColumn[];

    /**
     * Chek landscape.
     *
     * @return {boolean}
     */
    isLandscape() {

        return (window.orientation === 90 || window.orientation === -90);
    }

    /**
     * Bulk update factories after edit
     *
     * @param {IData[]} models Changed models
     */
    bulkUpdate(models: IData[]) {

        this.props.bulkUpdate(models);
    }

    /**
     * Render the component
     *
     * @return {JSX.Element}
     */
    render() {

        const { t, load } = this.props;

        return (
            <div className="with-list-component page-setting">
                <ScrollContainer
                    maxHeightSlider={`calc(100vh - ${isMobile ? this.isLandscape() ? 40 : 220 : 40}px)`}
                    headerScroll={
                        <div className="content-title-wrap">
                            <h2 className={'content-title factories'}>{t('FACTORIES')}</h2>
                            <Message
                                message={this.props.t('PLEASE_ENTER_A_UNIQUE_NAME')}
                                hidden
                            />
                        </div>
                    }
                    bodyStyle={{
                        paddingTop: 15,
                    }}
                >
                    <ListStickyHeader
                        columns={this.columns}
                        data={this.props.factories}
                        selectedParam={'id'}
                        refresh={load}
                        onSaveChanges={this.bulkUpdate}
                        maxHeightSlider={`calc(100vh - ${this.props.isLandscape ? 451 : 251}px)`}
                        minHeightSlider={'400px'}
                        defaultOrder={{
                            column: 'id',
                            dir: 'desc',
                        }}
                    />
                </ScrollContainer>
            </div>
        );
    }
}

/**
 * Map global state to component props
 *
 * @param {Object} state
 *
 * @return {Object}
 */
const mapStateToProps = (state: RootState) => {

    const { factories, errors } = state.factory,
        { refresh } = state.factoryChange;

    return {
        factories,
        errors,
        refresh,
    };
};

/**
 * Map dispatch to component props
 *
 * @type {object}
 */
const mapDispatchToProps = ({
    load: FactoryActions.list,
    bulkUpdate: FactoryActions.bulkUpdate,
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Factory));